import { z } from 'zod'

import { bridge } from '../bridge/bridge'
import { DEFAULT_POSITION } from '../constants'

export const SchemaPosition = z.object({
  lat: z.number(),
  lng: z.number(),
})

export type Position = z.infer<typeof SchemaPosition>

function makeCurrentPositionResource() {
  type State =
    | {
        _t: 'pending'
      }
    | {
        _t: 'resolved'
        result: Position | null
      }

  let state: State = {
    _t: 'pending',
  }

  const promise = (async () => {
    try {
      const result = await getCurrentPosition()

      state = {
        _t: 'resolved',
        result,
      }
    } catch (error) {
      state = {
        _t: 'resolved',
        result: null,
      }
    }
  })()

  return {
    read() {
      switch (state._t) {
        case 'pending':
          throw promise
        case 'resolved':
          return state.result
      }
    },
  }
}

export const currentPositionResource = makeCurrentPositionResource()

export async function getCurrentPosition(): Promise<Position | null> {
  if (DEFAULT_POSITION) {
    return {
      lat: Number(DEFAULT_POSITION.lat),
      lng: Number(DEFAULT_POSITION.lng),
    }
  }

  const result = await bridge.getCurrentPosition({})

  const {
    geolocation: { currentPosition },
  } = result

  return currentPosition?.position?.latitude && currentPosition?.position?.longitude
    ? {
        lat: currentPosition.position.latitude,
        lng: currentPosition.position.longitude,
      }
    : null
}
